import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Breadcrumb } from 'react-breadcrumbs'
import { withRouter } from 'react-router-dom'

import { PageTitle } from 'Components/PageTitle'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { InvoiceExportWrapper } from 'Components/Settings/InvoiceExport/InvoiceExportWrapper'
import { InvoiceExportTableWrapper } from 'Components/Settings/InvoiceExport/InvoiceTableWrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { getExportedXeros } from 'Reducers/Xero/actions'
import { getCountries } from 'Reducers/Countries/actions'
import { PATHS } from 'Config/Routing/paths'
import SettingsIcon from 'Assets/Images/icons/settings'
import SimpleTableTable from './../../../Components/SimpleTableTable'
import { getReadbleDateStringV2 as getReadbleDateString } from './../../../shared/libraries/utils/date'
import FileDownloadIcon from 'Assets/Images/icons/fileDownload'
import styled from 'styled-components'
import { convertWeekAndYearToString, weekSort } from '../../../Utils/Table'

export const ExportFileDownloadIcon = styled(FileDownloadIcon)`
  fill: ${props => props.theme.colors.regentGray};
  height: 18px;
  width: 18px;
`
class InvoiceExport extends PureComponent {
  componentDidMount = () => {
    this.props.getExportedXeros()
    this.props.getCountries()
  }

  render = () => (
    <InvoiceExportWrapper>
      <LayoutDashboard style={{ marginLeft: 20 }}>
        {this.renderBreadcrumbs()}
        <PageTitle>Invoice Export Files</PageTitle>
      </LayoutDashboard>
      {this.renderInvoicesTable()}
    </InvoiceExportWrapper>
  )

  renderBreadcrumbs = () => (
    <div>
      <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
      <Breadcrumb
        data={{
          title: 'Settings',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Invoice Export Files',
          pathname: this.props.match.url,
        }}
      />
    </div>
  )
  renderInvoicesTable = () => {
    return (
      <InvoiceExportTableWrapper>
        <HideWhenBlocked>
          <p
            style={{
              backgroundColor: 'white',
              paddingLeft: 65,
              paddingRight: 65,
              fontSize: 13,
            }}
          >
            WARNING: Dates will be in the format DD/MM/YYYY and will not adhere
            to your locale. <strong>Be careful if you're in the US!</strong>
          </p>
          <SimpleTableTable
            header={[
              'URL',
              'Year',
              'Week',
              'Country Code',
              'Created',
              'Actions',
            ]}
            data={this.props.invoices}
            filterOn={[
              {
                label: 'Week',
                sort: function(a, b) {
                  return weekSort(b, a)
                },
                sorted: false,
              },
              'Country Code',
              { label: 'Year', sort: numericSort, sorted: false },
            ]}
            postRowRender={o => ({
              ...o,
              'URL': (
                <a target="_blank" href={o['URL']}>
                  {trimURL(o['URL'])}
                </a>
              ),
              'Actions': (
                <div className="actions-cell">
                  <a target="_blank" href={o['URL']}>
                    <ExportFileDownloadIcon />
                  </a>
                </div>
              ),
            })}
          />
        </HideWhenBlocked>
      </InvoiceExportTableWrapper>
    )
  }
}

InvoiceExport.propTypes = {
  invoices: PropTypes.array.isRequired,
  getExportedXeros: PropTypes.func.isRequired,
}

const mapStateToProps = ({ xero, countries }) => ({
  invoices: xero.xeros.map(x => ({
    id: x.id,
    'URL': x.url,
    'Week': convertWeekAndYearToString({ year: x.year, weekNumber: x.week }),
    'Year': x.year,
    'Country Code': x.countryCode,
    'Created': getReadbleDateString(new Date(x.createdAt)),
  })),
  countriesList: countries.countriesList.map(c => c.code),
})

export default connect(
  mapStateToProps,
  {
    getExportedXeros,
    getCountries,
  },
)(withRouter(InvoiceExport))

const numericSort = function(a, b) {
  a = Number(a)
  b = Number(b)
  if (a > b) return -1
  if (a < b) return 1
  return 0
}

/**
 * Trims the noise out the Xero URL
 */
const trimURL = function(xeroUrl) {
  return xeroUrl.slice(0, xeroUrl.indexOf('?'))
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/InvoiceExport/index.js